module.exports = __webpack_public_path__ + "static/media/ucla-samueli-engineering.a1880337.png";